// extracted by mini-css-extract-plugin
export default {"container":"uj-z","bubbleNav":"vj-z","graphic":"wj-z","contact":"xj-z"};